// Mesquite Mafia: Syndicate Induction Tutorial Engine
import { state, log, updateCurrencies, updateHUDDirective, switchTab } from '../core/state.js';
import { playSFX } from '../core/audio.js';
import { playActionSequence } from '../core/kinematics.js';
import { playerProfile, SYNDICATE_CHARACTERS, updateProfileUI } from '../dossiers/characters.js';
import { updateStartScreenState, syncStateToD1 } from '../services/api.js';

export let tutorialSelectedArchetype = 'enforcer';
export let tutorialSelectedAvatar = 'art/characters/fat_twin.jpg';
export let tutorialSelectedRole = 'Micah "Fat Twin"';

export function openTutorialModal(step = 1) {
  const m = document.getElementById('modal-syndicate-tutorial');
  if (!m) return;
  playSFX('tab_switch');
  m.style.display = 'flex';
  setTutorialStep(step);

  const input = document.getElementById('tutorial-input-handle');
  if (input && (!input.value || input.value === "[ ROOKIE BOSS ]" || input.value === "UNREGISTERED BOSS")) {
    const presets = ["Galloway_Ghost", "Viper_635", "Shadow_Don", "Mesquite_Outlaw", "Dallas_Phantom", "Iron_Reaper", "Neon_Kingpin", "Highway_Wolf"];
    input.value = presets[Math.floor(Math.random() * presets.length)];
  }
}

export function closeTutorialModal() {
  const m = document.getElementById('modal-syndicate-tutorial');
  if (m) {
    m.style.display = 'none';
    playSFX('click');
  }
}

export function setTutorialStep(step) {
  playSFX('click');
  for (let i = 1; i <= 3; i++) {
    const c = document.getElementById('tutorial-step-' + i);
    if (c) c.classList.toggle('active', i === step);
    const pip = document.getElementById('pip-step-' + i);
    if (pip) pip.classList.toggle('active', i <= step);
  }
  const badge = document.getElementById('tutorial-step-badge');
  if (badge) badge.innerText = `STEP ${step} / 3`;
  const title = document.getElementById('tutorial-title');
  if (title) {
    if (step === 1) title.innerText = "MESQUITE SYNDICATE INDUCTION // STEP 1: IDENTITY WIRE";
    if (step === 2) title.innerText = "ROOM 114 OPERATIONS // STEP 2: LAUNDERING & COOKING";
    if (step === 3) title.innerText = "UNDERWORLD NETWORK // STEP 3: INFOGRAPHICS & BOUNTY";
  }
}

export function selectTutorialArchetype(el) {
  playSFX('click');
  document.querySelectorAll('#tutorial-step-1 .archetype-card').forEach(c => c.classList.remove('active'));
  el.classList.add('active');
  tutorialSelectedArchetype = el.getAttribute('data-archetype') || 'enforcer';
}

export function selectTutorialAvatar(el) {
  playSFX('click');
  document.querySelectorAll('#tutorial-step-1 .avatar-choice-card').forEach(c => c.classList.remove('active'));
  el.classList.add('active');
  tutorialSelectedAvatar = el.getAttribute('data-avatar') || 'art/characters/fat_twin.jpg';
  tutorialSelectedRole = el.getAttribute('data-role') || 'Micah "Fat Twin"';
}

export function randomizeTutorialHandle() {
  playSFX('click');
  const names = [
    "Galloway_Ghost", "Viper_635", "Shadow_Don", "Mesquite_Outlaw",
    "Dallas_Phantom", "Iron_Reaper", "Neon_Kingpin", "Highway_Wolf",
    "Deadlock_Don", "635_Striker", "Apex_Predator", "Concrete_King"
  ];
  const picked = names[Math.floor(Math.random() * names.length)];
  const input = document.getElementById('tutorial-input-handle');
  if (input) input.value = picked;
}

export function submitTutorialStep1() {
  const input = document.getElementById('tutorial-input-handle');
  const err = document.getElementById('tutorial-name-error');
  const raw = input ? input.value.trim() : "";

  if (!raw || raw.length < 3) {
    if (err) {
      err.innerText = "⚠️ Boss Alias must be at least 3 characters long.";
      err.style.display = 'block';
    }
    return;
  }
  if (err) err.style.display = 'none';

  playerProfile.handle = raw;
  playerProfile.archetype = tutorialSelectedArchetype;
  playerProfile.avatar = tutorialSelectedAvatar;
  playerProfile.role = tutorialSelectedRole;

  localStorage.setItem("mesquite_player_handle", playerProfile.handle);
  localStorage.setItem("mesquite_boss_profile", JSON.stringify(playerProfile));

  if (typeof updateProfileUI === 'function') {
    updateProfileUI();
  } else if (window.updateProfileUI) {
    window.updateProfileUI();
  }

  playSFX('vault');
  setTutorialStep(2);
}

export function finishTutorial() {
  playSFX('vault');
  state.cash = (state.cash || 500) + 250;
  state.scrap = (state.scrap || 50) + 50;
  state.cred = (state.cred || 25) + 25;
  updateCurrencies();

  localStorage.setItem("mesquite_tutorial_completed", "true");
  closeTutorialModal();

  if (typeof playActionSequence === 'function') {
    playActionSequence({
      title: "INDUCTION BOUNTY CLAIMED",
      icon: "👑",
      detail: `Boss ${playerProfile.handle} took command of Room 114!`,
      rewardText: "+$250 Cash • +50 Hardware Scrap • +25 Street Cred",
      shots: 2
    });
  }

  log(`[INDUCTION]: Boss "${playerProfile.handle}" completed tutorial induction.`);
  
  if (typeof switchTab === 'function') {
    switchTab('compound');
  } else if (window.switchTab) {
    window.switchTab('compound');
  }
}
